import React from "react";
import PlayWithFriends_challenge from "../components/PlayWithFriends_Challenge";

const PlayWithFriendsPage_challenge = () => {
  return (
    <div className=" bg-white p-3 rounded-xl">
      <div className="bg-[#0D99FF] text-white p-4 sm:p-5 rounded-t-md flex justify-between items-center mb-5s">
        <div>
          <h2 className="text-2xl font-semibold mb-1 text-white ">
            Challenge Your Friend
          </h2>
          <p className="text-sm opacity-90 text-white">
            Set goals, choose topics, or play with friends - it's your turn!
          </p>
        </div>
        <img
          src="/assets/images/robot.png"
          alt="Robot Icon"
          className="w-15 h-15 object-contain"
        />
      </div>
      <div className=" flex flex-col mt-10 items-center gap-4">
        <PlayWithFriends_challenge />
      </div>
    </div>
  );
};

export default PlayWithFriendsPage_challenge;
